var E = /* @__PURE__ */ ((_) => (_.TREATED = "treated", _.NOT_TREATED = "not_treated", _.DELETED = "deleted", _.PENDING_AUTO_REPLY = "pending_auto_reply", _.TREATED_AUTO_REPLY = "treated_auto_reply", _))(E || {});
const e = "review_assign_tag", r = "review_reply_suggestion", T = "review_create_reply_template";
export {
  e as REVIEW_PERMISSION_ASSIGN_TAG,
  T as REVIEW_PERMISSION_CREATE_REPLY_TEMPLATE,
  r as REVIEW_PERMISSION_REPLY_SUGGESTION,
  E as ReviewStateEnum
};
